/*
  Kelvin — study link click tracking.
  Publishes a Shopify customer event "study_link_click" for every click on
  a[data-study] (Customer events API: Shopify.analytics.publish). Read it from
  a custom pixel in Settings > Customer events with
  analytics.subscribe('study_link_click', event => { ... }).
*/
(function () {
  if (window.__kelvinStudyLinks) return;
  window.__kelvinStudyLinks = true;

  function track(e) {
    if (e.type === 'auxclick' && e.button !== 1) return;
    var link = e.target && e.target.closest ? e.target.closest('a[data-study]') : null;
    if (!link) return;
    var detail = {
      study: link.getAttribute('data-study'),
      url: link.href,
      placement: link.getAttribute('data-study-placement') || ''
    };
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('study_link_click', detail);
      }
    } catch (err) {
      /* tracking must never block the link */
    }
  }

  document.addEventListener('click', track, true);
  document.addEventListener('auxclick', track, true);
})();
